import { fillParentContainer } from 'fancy-textfill';
import whenDomReady from 'when-dom-ready';
whenDomReady().then(() => {
    const elements = Array.from(document.querySelectorAll('.js-fit-text'));
    for (const element of elements) {
        fillParentContainer(element, {
            multiline: true,
        });
    }
});
